import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import CruiseRescheduleAddOnsTable from './add-ons-table';
import CruiseRescheduleGuestTable from './guest-table';
import { ScheduleCardHeader } from '../../style';

export default function CruiseRescheduleItemCard(props: {
  parentIndex: number;
}) {
  const { t } = useTranslation();

  return (
    <CardSection>
      <ScheduleCardHeader $style={headerStyle}>
        <Text variant="HeadingXSmall">
          {t('ticketSales:cruise_sale_details')} {props.parentIndex + 1}
        </Text>
      </ScheduleCardHeader>
      <Separator gap={20} />

      <CruiseRescheduleGuestTable parentIndex={props.parentIndex} />
      <Separator gap={8} />

      <CruiseRescheduleAddOnsTable parentIndex={props.parentIndex} />
    </CardSection>
  );
}

const headerStyle: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
};
